<template>
  <div>
    <div v-if="badParam"><h3 class="center top-msg">下载地址格式不正确！</h3></div>
    <div v-else>
      <!-- <Preloader></Preloader> -->
      <!-- main wrapper start -->
      <div class="pa-main-wrapper">
        <Header :goto="goto" :myHide="myHide" @redirect="goHome()"></Header>
        <!-- about start -->
        <div class="pa-about spacer-top spacer-bottom">
          <div class="hg-about">
              <p><i class="el-icon-document grey"></i> {{file.name}}</p>
          </div>
          <div class="container">
              <div class="row">
                  <div class="col-lg-5">
                      <div class="pa-about-content">
                          <div class="pa-heading hg-upheader">
                              <h1>文件有效期剩余：<span id="remain">{{file.remainTime}}</span></h1>
                              <h5 class="down-title">文件信息</h5>
                          </div>
                          <p>文件名称：{{file.name}}</p>
                          <p>文件类型：{{file.ext}}</p>
                          <p>文件大小：{{file.size}}</p>
                          <p>下载次数：{{file.downTimes}}</p>
                          <p>过期时间：{{file.expireAt}}</p>
                      </div>
                  </div>
                  <div class="col-lg-7">
                      <div class="down-link">
                          <div class="down-title">点击下载</div>
                          <button type="button" class="pa-btn" @click="downloadFile"><i class="el-icon-bottom"></i> 下载文件</button>
                      </div>
                      <div class="down-title">扫二维码下载</div>
                      <div class="qrcode-bg">
                          <img class="down-qrcode hide" alt="qrcode" />
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <!-- about end -->
        <!-- how it works start -->
        <div class="pa-counter spacer-top spacer-bottom">
            <div class="container">
                <div class="pa-heading hg-center">
                    <h1>使用流程</h1>
                    <div id="hg-workflow">
                        <h5>1. &ensp;上传文件，获得下载链接和二维码。</h5>
                        <h5>2. &ensp;分享链接/二维码，下载文件。</h5>
                        <h5>3. &ensp;15分钟到期，文件永久删除。</h5>
                    </div>
                </div>
            </div>
        </div>
        <!-- how it works end -->
        <Copyright></Copyright>
      </div>
      <div id="missed-notice" class="hide">
        <p>糟糕，你来晚了。文件已删除！</p>
        <p class="go-home-countdown">{{missedCountDown}}s <a href="/">返回首页</a></p>
      </div>
    </div>
 </div>
</template>

<script>
import Preloader from '../../components/Preloader'
import Header from '../../components/Header'
import Copyright from '../../components/Copyright'
import FileUrl from '../../api/file.api'
import Routes from '../routes'
import Utils from '../../utils/utils'

export default {
  name: 'Get',
  components: {Preloader, Header, Copyright},
  data () {
    return {
      goto: '去上传',
      myHide: false,
      fid: null,
      badParam: false,
      removed: false,
      file: {
        name: null,
        ext: '',
        size: '',
        downTimes: null,
        expireAt: '',
        remainTime: '-- : --',
        qrCodeUrl: ''
      },
      missedCountDown: 12,
      missedTimer: null,
    }
  },
  created () {
    // do something after a vue instance was created
    this.fid = this.$route.params.fid
    console.log('created.')
    // validate param
    this.validateParam(this.fid)
  },
  async mounted () {
    console.log('mounted.')
    if (this.badParam) {
      return false
    }

    // get file info
    await this.getFileInfo(this.fid)
    // show missed message
    this.showMissed(this.removed)
  },
  methods: {
    validateParam (fid) {
      var re = /^[a-z0-9][a-z0-9][a-z0-9]+-[a-z0-9][a-z0-9][a-z0-9]$/;
      if(!re.test(fid)){
        this.badParam = true
      }
    },
    async getFileInfo (fid) {
      // get file info
      let params = {
        fid: fid
      }
      let res = await this.$api.syncPost(FileUrl.info, params)
      if (res.status === 0) {
        this.file.name = res.data.file_name
        this.file.ext = res.data.file_name.substr(res.data.file_name.lastIndexOf(".")+1)
        this.file.size = res.data.size
        this.file.downTimes = res.data.down_times
        this.file.expireAt = res.data.expire_at
        this.file.qrCodeUrl = res.data.qrcode_path
        // 显示二维码
        $('.down-qrcode').attr('src', this.file.qrCodeUrl)
        $('.down-qrcode').show()
        // 显示倒计时
        this.countDownInMinSec(res.data.expire_ts - parseInt(Date.now()/1000))
      }
      if (res.status === 1) {
        this.$message({
         type: 'error',
         message: res.error
        })
      }
      if (res.status === 2) {
        this.removed = true
      }
    },
    showMissed (isRemoved) {
      if (isRemoved) {
        //hide main wrapper
        $('.pa-main-wrapper').hide()
        //show missed message
        $('#missed-notice').show()
        //start go home page countdown (12 seconds)
        if (!this.missedTimer) {
            const TIME_COUNT = 12
            this.missedCountDown = TIME_COUNT
            this.missedTimer = setInterval(() => {
                if (this.missedCountDown > 0 && this.missedCountDown <= TIME_COUNT) {
                    this.missedCountDown--
                } else {
                    clearInterval(this.missedTimer)
                    this.missedTimer = null
                    this.goHome()
                }
            }, 1000)
        }
      }
    },
    goHome() {
      this.$router.push(Routes.Home)
    },
    countDownInMinSec(totalSeconds) {
      let that = this
      var timer = null
      var t = totalSeconds

      function countDown() {
          t--
          if (t <= 0) {
              clearInterval(timer)
              that.removed = true
          }
          that.file.remainTime = Utils.formatSeconds(t)
      }
      timer = setInterval(countDown,1000)
    },
    downloadFile() {
      if (this.removed) {
        this.$message.warning('文件已过期')
      } else if (!this.file.name) {
        this.$message.warning('文件信息错误')
      } else {
        //console.log('do download')
        window.location.href = Utils.baseUrl+'/file/download?fid='+this.fid

        /**
         * 不用接口调用方式
        let params = {
          fid: this.fid
        }
        this.$api.get(FileUrl.download, params, r => {
          // success
        }, r => {
          // error
          this.$message({
            type: 'error',
            message: r.error
          })
        })
        */
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .center {
    text-align: center;
  }
  .top-msg {
    margin-top: 2rem;
  }
  .grey {
    color: #999;
  }
  .hide {
    display: none;
  }
  .pa-about-content p {
    margin-bottom: 0.5rem;
  }
  i {
    font-size: 16px;
  }
  .hg-about i {
    font-size: 26px;
  }
  #remain {
    font-size: 2.5rem;
  }
  #missed-notice {
    text-align: center;
    margin-top: 60px;
  }
  #missed-notice p {
    margin-bottom: 2rem;
    text-transform: capitalize;
    font-size: 32px;
    line-height: 1.5;
  }
  #missed-notice a {
    font-size: 20px;
    color: #6caaa8;
  }
  #missed-notice .go-home-countdown {
    font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/get/get.vue